import axios from 'axios'
import DiagnosisOptionsTransformer from 'transformers/DiagnosisOptionsTransformer'

export default {
    getFromICD10(searchTerm, searchField) {
        return axios.get('icd10-codes', {
            params: {
                query: searchTerm,
                searchField: searchField,
            },
            transformResponse: [DiagnosisOptionsTransformer.transform('id', 'name')],
        })
    },
}
